// extracted by mini-css-extract-plugin
module.exports = {"deleteRuleButton":"RuleBuilderCoreAdapter_deleteRuleButton__NdbQD","dividerContainer":"RuleBuilderCoreAdapter_dividerContainer__2bLXt"};